import React, { useContext, useEffect, useState } from "react";
import styles from './ProjectPublish.module.scss'
import { connect } from "react-redux";
import { CardItem } from "../../../../../../components/card/Card";
import Input from "../../../../../../components/Input";
import CategoriesEditor from "./components/CategoriesEditor";
import { updateBodyBuilder } from "../../../../../../redux/actions/DeploymentActions";
import Messages from "../../../../../../components/Messages";
import Button from "../../../../../../components/ripple/Button";
import { CardContext } from "../../../../../../components/card/CardAdvanced";

function ProjectPublish({
                            categories, tags, messages,
                            dispatch, bodyBuilder, ...props
                        }) {

    const cardContext = useContext(CardContext)

    const [showShort, setShowShort] = useState(false);
    const [showLong, setShowLong] = useState(false);

    const [short, setShort] = useState(bodyBuilder.project_overview);
    const [full, setFull] = useState(bodyBuilder.project_description);

    useEffect(() => {
        // set from local storage
        setShort(bodyBuilder.project_overview);
        setFull(bodyBuilder.project_description);
        //
        if (!!bodyBuilder.project_overview?.length && !showShort) setShowShort(true);
        if (!!bodyBuilder.project_description?.length && !showLong) setShowLong(true);
    }, [
        bodyBuilder.project_overview,
        bodyBuilder.project_description
    ]);

    const highlightedButton = messages.find(m => m.container === `blah-blah-blah` && m.target === 'add-button');
    const highlightedButtonStyles = highlightedButton ? ' ' + styles[`add--highlight`] : '';

    //

    return (
        <>
            <CardItem>
                <Messages
                    messages={[{
                        message: `If you intend to publish your project on TryDirect’s marketplace, please complete the following form. Our security team will review and validate your request, and once it has successfully passed the verification process, it will be visible on the marketplace dashboard.`,
                        type: 'info',
                    }]}
                />
            </CardItem>
            <CardItem id='project-settings-category' messages={messages}>
                <Messages messages={messages} target='project-settings-category'/>
                <CategoriesEditor
                    title='Category'
                    value={bodyBuilder.custom_stack_category || []}
                    suggestions={tags}
                    onChange={arr => dispatch(updateBodyBuilder({custom_stack_category: arr}))}
                />
            </CardItem>
            <CardItem>
                {
                    !!showShort
                        ?
                        <Input
                            type='textarea'
                            name='project_overview'
                            placeholder='Short Project Overview'
                            iconLeft='fas fa-cubes'
                            value={short}
                            onChange={e => {
                                const {value} = e.target;
                                dispatch(updateBodyBuilder({project_overview: value}));
                                setShort(value);
                            }}
                        />
                        :
                        <Button
                            className={`${styles.add}${highlightedButtonStyles}`}
                            title='Add short description'
                            iconLeft='fas fa-plus'
                            displayType={highlightedButton ? 'contained' : 'text'}
                            onClick={() => {
                                setShowShort(true);
                                cardContext.calculateHeight();
                            }}
                            visuals={{
                                borderRadius: '20px',
                                height: '4rem',
                                colorBasic: highlightedButton
                                    ? highlightedButton.type === 'error'
                                        ? ['var(--colorFontError)']
                                        : highlightedButton.type === 'warning' ? ['var(--colorFontWarning)'] : []
                                    : [],
                            }}
                        />
                }
                {
                    !!showLong
                        ?
                        <Input
                            type='textarea'
                            name='project_description'
                            placeholder='Full Project Description'
                            iconLeft='fas fa-cubes'
                            value={full}
                            onChange={e => {
                                const {value} = e.target;
                                dispatch(updateBodyBuilder({project_description: value}));
                                setFull(value);
                            }}
                        />
                        :
                        <Button
                            className={`${styles.add}${highlightedButtonStyles}`}
                            title='Add full description'
                            iconLeft='fas fa-plus'
                            displayType={highlightedButton ? 'contained' : 'text'}
                            onClick={() => {
                                setShowLong(true);
                                cardContext.calculateHeight();
                            }}
                            visuals={{
                                borderRadius: '20px',
                                height: '4rem',
                                colorBasic: highlightedButton
                                    ? highlightedButton.type === 'error'
                                        ? ['var(--colorFontError)']
                                        : highlightedButton.type === 'warning' ? ['var(--colorFontWarning)'] : []
                                    : [],
                            }}
                        />
                }
            </CardItem>
        </>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
});

export default connect(mapStateToProps)(ProjectPublish)